export enum ShiftStatus {
  Unknown = -1,
  Success = 0,
  Warn = 1,
  Error = 2
}
